import React from "react";

export default function SQL_Auto_Increment() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Auto_Increment</h1>
      <p>This is the SQL_Auto_Increment component generated from the SQL JSON.</p>
    </div>
  );
}
